import Configs from "./publicRuntimeConfig"
 
function checkAppEnv() {
  return Configs?.appENV != "dr" && Configs?.appENV != "prod"
}

function error(...args) {
  if (checkAppEnv()) {
    console.log("%c [ERROR]", "color: white; background-color: #ff0000", args)
  }
}

function info(...args) {
  if (checkAppEnv()) {
    console.log("%c [INFO]", "color: white; background-color: #14a10d", args)
  }
}

export default {
  error,
  info
}
